
import React from "react";
import { Layout } from "@/components/layout/Layout";
import { MessageCircle, ExternalLink } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

const Support = () => {
  const { user } = useAuth();

  return (
    <Layout>
      <div className="p-6 animate-fade-in">
        <h1 className="text-2xl font-semibold mb-6 flex items-center">
          <MessageCircle className="mr-3 text-[#41c7f0]" size={24} />
          Support
        </h1>
        
        <div className="glass-morphism rounded-xl p-8 border border-gray-800/30 max-w-2xl bg-gradient-to-br from-[#1E1E1E]/90 to-[#151515]/90 shadow-xl">
          <div className="flex flex-col items-center justify-center py-8">
            <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#41c7f0]/20 to-[#41c7f0]/5 flex items-center justify-center mb-6 border border-[#41c7f0]/30 shadow-lg shadow-[#41c7f0]/5">
              <MessageCircle className="text-[#41c7f0]" size={36} />
            </div>
            <h2 className="text-2xl font-semibold mb-3 text-gradient">Wie können wir Ihnen helfen?</h2>
            <p className="text-gray-400 text-center mb-8 max-w-md">Elite Consulting für visionäre Investoren. Unser Support-Team steht Ihnen jederzeit zur Verfügung.</p>
            
            <div className="w-full max-w-md p-6 bg-[#0c0c0c]/70 rounded-lg border border-gray-800/30 shadow-inner">
              <p className="text-gray-300 mb-6">
                {user ? 
                  `Hallo ${user.name}, wie können wir Ihnen helfen?` : 
                  'Bitte melden Sie sich an, um den Support zu nutzen.'}
              </p>
              
              <div className="flex flex-col space-y-3">
                <Button 
                  className="w-full bg-gradient-to-r from-[#41c7f0] to-[#3ab7de] hover:opacity-90 shadow-md shadow-[#41c7f0]/10"
                >
                  <MessageCircle size={18} className="mr-2" />
                  Chat starten
                </Button>
                
                <Button 
                  variant="outline" 
                  className="w-full border-gray-700 bg-transparent hover:bg-gray-800/30 text-gray-300"
                >
                  <ExternalLink size={18} className="mr-2" />
                  FAQ besuchen
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Support;
